import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/core/services/config.service';
import { ToastService } from 'src/app/core/services/toast-service';
import { SessionQuery } from 'src/app/core/state-mangement/session/session.query';

@Component({
  selector: 'app-user-profile-toolbar',
  templateUrl: './user-profile-toolbar.component.html',
  styleUrls: ['./user-profile-toolbar.component.scss'],
})
export class UserProfileToolbarComponent implements OnInit {
  userName$: Observable<string>;
  personName$: Observable<string>;
  backendUrl: string;
  userNum: number;
  userName: string;
  personName: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private sessionQuery: SessionQuery,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    this.userName$ = this.sessionQuery.admiaNumberandName$;
    this.personName$ = this.sessionQuery.numberAndName$;

    this.sessionQuery.idPerson$.subscribe((val) => {
      if (val) {
        this.prepareAvatarImageUrl(val);
        this.userNum = val;
      }
    });

    this.sessionQuery.admiaNumberandName$.subscribe((val) => {
      if (val) {
        this.userName = val;
      }
    });

    this.sessionQuery.numberAndName$.subscribe((val) => {
      if (val) {
        this.personName = val;
      }
    });
  }

  //NOTE
  //hardcoded JPG FileType
  //currently only JPG is supported, caused by Missing handling for other types
  //Expense Reports also go hardcoded for JPG
  prepareAvatarImageUrl(personId: number) {
    this.backendUrl = AppConfig.settings.backend.url;
    this.backendUrl = this.backendUrl.replace(
      'api/',
      'depot/Pictures/Personal/' + personId + '.jpg'
    );
  }

  async canDismiss(role?: string) {
    return role !== 'gesture';
  }
}
